export default "__VITE_ASSET__df__VFsl__"